import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, PDFDownloadLink } from '@react-pdf/renderer';
import Logo from '../certificados/logoISePGoyenechea.png'
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 12 },
  section: { marginBottom: 10, padding: 10, border: '1px solid #000' },
  title: { fontSize: 16, marginBottom: 10, textAlign: 'center', fontWeight: 'bold' },
  image: { width: 60, height: 60, alignSelf: 'center', marginBottom: 10 },
});

const PDFDocument = ({ datos }) => (
  <Document>
    <Page size="A4" style={styles.page}>
     <Image style={{width:"150px", position:"relative", alignSelf:"flex-end", marginTop:"-17px", marginRight:"10px"}} src={Logo}/>
      <Text style={styles.title}>Información de Carpeta: {datos.id}</Text>
      <View style={styles.section}>
        <Text>Cadete: {datos.cadete.cadeteApellido}, {datos.cadete.cadeteNombre}</Text>
        <Text>DNI: {datos.cadeteDni}</Text>
        <Text>Sede: {datos.cadeteSede}</Text>
        <Text>Compañia: {datos.cadete.Seccion.Compania?.nombre}</Text>
      </View>
      <View style={styles.section}>
      <Text>Estado Carpeta: {datos.estado}</Text>
        <Text>Motivo Solicitud: {datos.motivoSolicitud}</Text>
        <Text>Usuario Recepciono: {datos.usuarioRecepciono}</Text>
        <Text>Tipo Diagnóstico: {datos.tipoDiagnostico}</Text>
        <Text>Diagnóstico o Recomendación : {datos.diagnostico}</Text>
        <Text>Personal Sanidad: {datos.medicoReviso}</Text>
       
      </View>
      <View style={styles.section}>
        <Text>Solicitado: {new Date(datos.fechaSolicitud).toLocaleString()}</Text>
        <Text>Revisado: {new Date(datos.updatedAt).toLocaleString()}</Text>
        <Text>Inicio Condición: {new Date(datos.iniciaCondicion).toLocaleString()}</Text>
        <Text>Finaliza Condición: {new Date(datos.finalizaCondicion).toLocaleString("es-AR")}</Text>
        <Text>Se aconsejo Pase de Salida: {datos.otorgaPaseSalida?"Si":"No"}</Text>
        
      </View>
    </Page>
  </Document>
);

const CarpetaInfo = ({ datos }) => {
const Usuario=ObtieneDatosCookies()
  return (
    <div style={{ maxWidth: '640px', maxHeight: '480px', overflow: 'auto', padding: '16px', backgroundColor: '#f3f4f6', borderRadius: '16px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <div>
          <p><strong>Apellido:</strong> {datos.cadete.cadeteApellido}, {datos.cadete.cadeteNombre}</p>
          <p><strong>DNI:</strong> {datos.cadeteDni}</p>
          <p><strong>Sede:</strong> {datos.cadeteSede}</p>
          <p><strong>Compañia:</strong> {datos.cadete.Seccion.Compania?.nombre}</p>
          <div style={{ marginTop: '16px' }}>
            <p><strong>Solicito:</strong> {new Date(datos.fechaSolicitud).toLocaleString()}</p>
            <p><strong>Fue Revisado:</strong> {new Date(datos.updatedAt).toLocaleString()}</p>
            <p><strong>Inicio Condición:</strong> {new Date(datos.iniciaCondicion).toLocaleString()}</p>
            <p><strong>Finaliza Condición:</strong> {new Date(datos.finalizaCondicion).toLocaleString()}</p>
          </div>
        </div>
        <div>
          <p><strong>Motivo Solicitud:</strong> {datos.motivoSolicitud}</p>
          <p><strong>Diagnóstico:</strong> {datos.diagnostico}</p>
          <p><strong>Estado:</strong> {datos.estado}</p>
          <p><strong>Tipo Diagnóstico:</strong> {datos.tipoDiagnostico}</p>
          <p><strong>Personal Sanidad:</strong> {datos.medicoReviso}</p>
          <p><strong>Usuario Recepcionó:</strong> {datos.usuarioRecepciono}</p>
          <p><strong>Otorga Pase de Salida:</strong> {datos.otorgaPaseSalida}</p>
        </div>
      </div>
      {Usuario.nivel<3?<PDFDownloadLink document={<PDFDocument datos={datos} />} fileName={`carpeta_info_${datos.cadeteDni}_${new Date(datos.finalizaCondicion).toLocaleString()}.pdf`} >
        {({ loading }) => (loading ? 'Generando PDF...' : <div className='btn btn-success'>Descargar</div>)}
      </PDFDownloadLink>:""}
      
    </div>
  );
};

export default CarpetaInfo;
